import React, { useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import RotateLeftIcon from "@material-ui/icons/RotateLeft";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { useSnackbar } from "notistack";

const useStyles = makeStyles((theme) => ({
	paper: {
		marginTop: theme.spacing(8),
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: "100%", // Fix IE 11 issue.
		marginTop: theme.spacing(1),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
}));

export default function ResetPassword(props) {
	const { token } = useParams();
	const history = useHistory();
	const classes = useStyles();
	const [password, setPassword] = useState();
	const { enqueueSnackbar } = useSnackbar();

	const onChange = (e) => {
		setPassword({ ...password, [e.target.name]: e.target.value });
	};

	const onSubmit = (e) => {
		e.preventDefault();

		//Remove any keys with an empty str as the value
		for (const key of Object.keys(password)) {
			if (password[key] === "") {
				delete password[key];
			}
		}

		//Make sure passwords match
		if (password.password !== password.confirmPassword) {
			return enqueueSnackbar("The passwords don't match. Please try again.", {
				variant: "error",
			});
		}

		fetch(`${process.env.REACT_APP_API_URL}/auth/resetpassword/${token}`, {
			method: "PUT",
			credentials: "include",
			body: JSON.stringify(password),
			headers: { "Content-Type": "application/json" },
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.success) {
					enqueueSnackbar("Password changed successfully!", {
						variant: "success",
					});
					history.push(`/${process.env.REACT_APP_ADMIN_URL}/login`);
				} else {
					console.log(data);
					const errorArray = data.error.split(",");
					errorArray.forEach((error) => {
						enqueueSnackbar(`${error}`, { variant: "error" });
					});
				}
			});
	};

	return (
		<Container component="main" maxWidth="xs">
			<div className={classes.paper}>
				<Avatar className={classes.avatar}>
					<RotateLeftIcon />
				</Avatar>
				<Typography component="h1" variant="h5">
					Reset Password
				</Typography>
				<form className={classes.form} onSubmit={onSubmit}>
					<TextField
						variant="outlined"
						margin="normal"
						required
						fullWidth
						name="password"
						label="Password"
						type="password"
						id="password"
						onChange={onChange}
					/>
					<TextField
						variant="outlined"
						margin="normal"
						required
						fullWidth
						name="confirmPassword"
						label="Confirm Password"
						type="password"
						id="confirmPassword"
						onChange={onChange}
					/>
					<Button
						type="submit"
						fullWidth
						variant="contained"
						color="primary"
						className={classes.submit}
					>
						Set New Password
					</Button>
				</form>
			</div>
		</Container>
	);
}
